import { render, staticRenderFns } from "./vFormPublishingMixin.js.vue?vue&type=template&id=5984d9b4&"
import script from "./vFormPublishingMixin.js.vue?vue&type=script&lang=js&"
export * from "./vFormPublishingMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports